import fetchTimeout from "../utils/fetchTimeout";
import { IClient, IClientRequest, IDisitrictsRequest, IDistrict, IDocumentTypesRequest } from "../interfaces/cliente";
import { setHeaders, URL_REQUEST } from "./constants";
import { decodeTokenLS } from "../utils/token";

export async function getDocumentList(): Promise<IDocumentTypesRequest> {
    let response: IDocumentTypesRequest;
        let res: any = await fetchTimeout(URL_REQUEST + "/api/v1/general/documentoidentidad", {
            "headers": setHeaders(),
            "body": null,
            "method": "GET",
        });
        response = await res.json();
        if (response.status === "200") {
            return response;
        }
        throw new Error("No se pudo obtener la lista de documentos, por favor revise su conexión a internet y recargue la página");
}
export async function getClient(documentNumber: string, documentType: number): Promise<IClient | null> {
    let raw = '';
    const decoded = decodeTokenLS();
    if (decoded) {
        const empresaId = decoded.user.empresaId;
        raw = JSON.stringify({
            tipoDocumentoId: documentType,
            nroDocumento: documentNumber,
            empresaId
        });
    }
    let response: IClientRequest;
    let res: any = await fetchTimeout(URL_REQUEST + "/api/v1/admin/cliente/buscarClientePorDocumento", {
        "headers": setHeaders(),
        "body": raw,
        "method": "post",
    });
    response = await res.json();
    if (response.status === "200") {
        return response.data;
    }

    // Cliente no existe en esta empresa. Intentamos enriquecer con API externa (solo DNI).
    // Se usa perudevs.com (migrado desde api-peru.com que caducó en 2026-03).
    if (documentType === 2) {
        try {
            const PERUDEVS_KEY = "cGVydWRldnMucHJvZHVjdGlvbi5maXRjb2RlcnMuNjlhYjA5NzQwNGEyNjc2MDk2ZjkzZDky";
            const resPeruDevs = await fetchTimeout(
                `https://api.perudevs.com/api/v1/dni/complete?document=${documentNumber}&key=${PERUDEVS_KEY}`,
                { "method": "GET" },
                5000
            );
            type ResponsePeruDevs = {
                estado: boolean,
                mensaje: string,
                resultado?: {
                    id: string,
                    nombres: string,
                    apellido_paterno: string,
                    apellido_materno: string,
                    fecha_nacimiento: string, // DD/MM/YYYY
                    genero: string, // "M" | "F"
                    nombre_completo: string,
                }
            };
            const resJson: ResponsePeruDevs = await resPeruDevs.json();
            if (resJson.estado && resJson.resultado) {
                const { nombres, apellido_paterno, apellido_materno, fecha_nacimiento, genero } = resJson.resultado;
                // Transformar DD/MM/YYYY -> YYYY-MM-DD (formato esperado por input type=date)
                let fechaISO = "";
                if (fecha_nacimiento && fecha_nacimiento.includes("/")) {
                    const [dd, mm, yyyy] = fecha_nacimiento.split("/");
                    fechaISO = `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
                }
                const apellidoCompleto = [apellido_paterno, apellido_materno].filter(Boolean).join(" ");
                return {
                    nombre: nombres,
                    apellido: apellidoCompleto,
                    sexo: genero === "M" ? 1 : 2,
                    clienteId: null,
                    correo: "",
                    telefono: "",
                    fechaNacimiento: fechaISO,
                };
            }
        } catch (perudevsError) {
            // Falla silenciosa de la API externa — caemos al return null abajo.
            console.warn("API externa de DNI no disponible, el usuario completará datos manualmente:", perudevsError);
        }
    }

    // Cliente no encontrado ni en BD ni en API externa. Permitir captura manual.
    return null;
}

export async function getDistricts (): Promise<IDistrict[]> {
    let response: IDisitrictsRequest;
    let res: any = await fetchTimeout(URL_REQUEST + "/api/v1/ubigeo/buscarDistritos", {
        "headers": setHeaders(),
        "body": null,
        "method": "GET",
    });
    response = await res.json();
    if (response.status === "200") {
        return response.data;
    }
    throw new Error("No se pudo obtener la lista de distritos, por favor revise su conexión a internet y recargue la página");
}